module.exports = __webpack_public_path__ + "media/src/images/icons/lock-outline-cf12563ed4185d3b184a93575771eea9.svg";